import RestService from './RestService'

export default class DataService extends RestService {
    constructor(modelId) {
        super('data')
        this.modelId = modelId
    }

    get(parentId) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + this.modelId

        if (parentId) {
            url += '/' + parentId
        }

        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .end((error, response) => {
                    if (response.status === 200) {
                        const records = JSON.parse(response.text);
                        resolve(records);
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    save(document) {
        console.log('Data Service save')
        let request = {
            record: document
        }

        if (document['id']) {
            return this.update(request)
        } else {
            return this.create(request)
        }
    }

    create(request) {
        console.log('Data Service create')
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + this.modelId
        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(request)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        let oldDocument = request.record
                        let newDocument = JSON.parse(response.text)
                        oldDocument.id = newDocument.id
                        resolve(newDocument)
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    update(request) {
        console.log('Data Service update')
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + this.modelId
        return new Promise((resolve, reject) => {
            this.http.put(url)
                .send(request)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    remove(document) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + this.modelId
        let request = {
            record: document
        }
        return new Promise((resolve, reject) => {
            this.http.delete(url)
                .send(request)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }

                })
        })
    }

    getDocument(documentId) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + this.modelId + '/document/' + documentId
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .end((error, response) => {
                    if (response.status === 200) {
                        const record = JSON.parse(response.text);
                        resolve(record);
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}